/*
 * Copyright (c) 2023. Collabro Limited
 */
import React from "react";
import { PopoutScreenProps } from "../Options/Options";
import {
  Checkbox,
  Divider,
  IconButton,
  Popover,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import LayersList from "./LayersList";

const LayersScreen = (props: PopoutScreenProps) => {
  const handleClose = () => {
    props.onClose(null);
  };

  return (
    <Popover
      open={Boolean(props.anchorEl)}
      anchorEl={props.anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "center",
        horizontal: "left",
      }}
      PaperProps={{
        sx: {
          borderRadius: 3,
        },
      }}
    >
      <div
        style={{
          padding: 10,
          width: 410,
        }}
      >
        <IconButton onClick={handleClose}>
          <Close />
        </IconButton>
        <Divider>
          <Typography variant="h6">Layers</Typography>
        </Divider>
        <LayersList onClose={handleClose} width={400} showHeader={false} />
      </div>
    </Popover>
  );
};

export default LayersScreen;
